import { DocumentNode } from 'graphql';
import { getClient } from 'graphql/client';

export const chackAvailability = async (query: DocumentNode, input?: string, token?: string) => {
  const client = getClient(token);
  const { data } = await client.query({
    query,
    variables: { input },
  });
  return data;
}